import {useContext, useState} from 'react';
import { AppContext } from '../context/AppProvider';
import { ActionType } from '../assets/constants/constants';

const useSearchhook = () => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [keyword, setKeyword] = useState('');
  const { state, dispatch } = useContext(AppContext);
  const onhandleSearch = (e: any) => {
    setSearchKeyword(e.target.value);
    dispatch({ type: ActionType.SET_KEYWORD, payload: e.target.value });
    if (e.target.value.length < 1) {
      setKeyword('');
      dispatch({ type: ActionType.SET_KEYWORD , payload: '' });
    }
    if (e.key === 'Enter') {
      onSearchClick();
    }
  };
  const onSearchClick = () => {
    setKeyword(searchKeyword);
    dispatch({ type: ActionType.SET_KEYWORD, payload: state.keyword });
  };
  return {
    searchKeyword,
    keyword,
    onhandleSearch,
    onSearchClick,
  };
};

export default useSearchhook;
